import * as z from "zod/v4";

export const getCarrierDeliveryErrorsOverTime = {
  name: "getCarrierDeliveryErrorsOverTime" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    data: z.array(z.object({ date: z.string(), value: z.number() })),
  }),
};
